<!--
  详情页 - 合同产品信息
  props:
    id: 详情id
 -->

<template>
  <div class="v-tabs product-list">
    <div class="head">
      <div class="total">
        {{tableData.length}}种产品{{totalProducts}}件
      </div>
      <div class="inline-item" v-if="sumPrice">
        合同总计：{{sumPrice}}{{unit || '元'}}
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%"
        @click.native="tableClick">
        <el-table-column
          label="产品图片"
          width="75">
          <template slot-scope="scope">
            <img
              data-type="img"
              :data-url="scope.row.thumbnail"
              :src="scope.row.thumbnail"
              height="30"
              width="30">
          </template>
        </el-table-column>
        <el-table-column
          label="产品名称"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.productName}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="productNo"
          label="产品编号"
          width="80"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="产品规格"
          width="100"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.specification || '--'}}
          </template>
        </el-table-column>
        <el-table-column
          property="num"
          label="数量"
          width="80"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="备注"
          width="80"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.memo || '--'}}
          </template>
        </el-table-column>
        <el-table-column
          label="缺货"
          width="80"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="showRed(scope.row.lackNum)">
              {{scope.row.lackNum}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="stock"
          label="库存"
          width="80"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="单位"
          width="80"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.unit || '--'}}
          </template>
        </el-table-column>
        <el-table-column
          property="outstock"
          label="状态"
          width="80"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="productPrice"
          :label="'售价 ('+unit+')'"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="price"
          :label="'单价 ('+unit+')'"
          width="80"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="discount"
          label="折扣 (%)"
          width="80"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <span class="item">合计：{{totalPrice}}{{unit}};</span>
        <span class="item" :class="{'discount': item.surchargeType === 2}" v-for="item in surchargeList">{{item.surchargeName}}: {{item.amount | amount}}{{unit}};</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import lightBox from 'src/plugins/lightbox'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      otherCharge: 0,
      // 总价
      sumPrice: 0,
      // 单位
      unit: '元',
      tableData: [],
      surchargeList: [] // 优惠及其他费用
    }
  },
  computed: {
    // 产品总数
    totalProducts () {
      let i = 0
      this.tableData.forEach(item => {
        i = utils.plus(i, item.num)
      })
      return i
    },
    // 合同金额总计
    totalPrice () {
      let i = 0
      this.tableData.forEach((item) => {
        let mult = utils.multiply(item.productPrice, item.num)
        i = utils.plus(i, mult)
      })
      // 与新建编辑中的产品合计保持一致
      return Number(i.toFixed(6))
    }
  },
  methods: {
    getList () {
      let url = '/contractApi/getContractProducts.html'
      let params = {
        id: this.id
      }
      api.post(url, params, (data) => {
        this.tableData = data.productList
        this.sumPrice = data.others.sumPrice
        this.unit = data.others.unit || '元'
        this.surchargeList = data.surchargeList || []
      })
    },
    // 监听table点击事件
    tableClick (event) {
      // 获取目标元素或目标父元素的data属性集合
      let data = event.target.dataset
      // 如果存在type属性，则是一个可执行的事件
      if (data.type && data.type === 'img') {
        lightBox(data.url)
      }
    },
    // 缺货变红
    showRed (num) {
      if (num > 0) {
        return {
          color: '#ff6161'
        }
      }
    }
  },
  filters: {
    amount (value) {
      return value > 0 ? value : -value
    }
  }
}
</script>

<style lang="less" scoped>
.product-list .discount {
  color: #ff6161;
}
</style>



// WEBPACK FOOTER //
// product-list.vue?c2601070